export default __webpack_public_path__ + "static/media/duct-cleaning.53c7807a.png";